import React, { forwardRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

// Rendered off-screen at 360x640, exported at 3x => 1080x1920 story image
export const StoryCard = forwardRef(({ name, memberNumber, district, link }, ref) => (
  <div ref={ref} style={{ width: 360, height: 640, background: '#0B0B0F', fontFamily: "'Space Grotesk', sans-serif" }} className="relative overflow-hidden text-white">
    <div style={{ position: 'absolute', top: -80, right: -80, width: 260, height: 260, borderRadius: '50%', background: '#E30613', opacity: 0.55, filter: 'blur(40px)' }} />
    <div style={{ position: 'absolute', bottom: -60, left: -60, width: 240, height: 240, borderRadius: '50%', background: '#00A651', opacity: 0.5, filter: 'blur(40px)' }} />
    <div className="relative flex h-full flex-col justify-between p-8">
      <div>
        <p style={{ fontSize: 11, letterSpacing: 4, color: '#00E676', fontWeight: 700 }}>NDP · MEMBERSHIP DRIVE 2026</p>
        <p style={{ fontSize: 52, lineHeight: 1, fontWeight: 900, marginTop: 28 }}>I JUST<br />JOINED<br /><span style={{ color: '#FF3B3B' }}>NDP.</span></p>
        <p style={{ fontSize: 16, marginTop: 20, color: 'rgba(255,255,255,0.75)' }}>Gen Z is not waiting. We're building a new Bangladesh.</p>
      </div>
      <div style={{ borderRadius: 20, border: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.06)', padding: 16 }}>
        <p style={{ fontSize: 20, fontWeight: 800 }}>{name}</p>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>{district || 'Bangladesh'}</p>
        <p style={{ fontSize: 15, marginTop: 6, color: '#FFD60A', fontWeight: 700, letterSpacing: 1 }}>{memberNumber}</p>
      </div>
      <div className="flex items-end justify-between">
        <div>
          <p style={{ fontSize: 13, fontWeight: 700 }}>Scan & join me</p>
          <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)' }}>2 min · instant digital ID</p>
          <p style={{ fontSize: 11, color: '#00E676', marginTop: 4 }}>ndpbd.com/join</p>
        </div>
        <div style={{ background: '#fff', padding: 6, borderRadius: 12 }}>
          <QRCodeCanvas value={link} size={96} />
        </div>
      </div>
    </div>
  </div>
));
